import { type LayoutNode } from '@backend/lib/db/typeRoots/layoutNode'
import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

type Store = {
  historyData: LayoutNode[][]
  historyCursor: number

  addHistoryStep: (payload: LayoutNode[]) => void
  getCurrentHistory: () => LayoutNode[]

  canHistoryUndo: () => boolean
  canHistoryRedo: () => boolean
  historyUndo: () => void
  historyRedo: () => void
  resetHistory: () => void
}

export const nodeHistoryStore = create<Store>((set, get) => ({
  historyData: [],
  historyCursor: -1,

  addHistoryStep: (payload) => {
    set((state) => ({
      historyData: [...state.historyData.slice(0, state.historyCursor + 1), payload],
      historyCursor: state.historyCursor + 1,
    }))
  },
  getCurrentHistory: () => {
    const state = get()
    if (
      state.historyCursor === -1 ||
      state.historyCursor < 0 ||
      state.historyCursor >= state.historyData.length
    ) {
      return []
    }
    return state.historyData[state.historyCursor]!
  },

  canHistoryUndo: () => get().historyCursor > 0,
  canHistoryRedo: () => get().historyCursor < get().historyData.length - 1,
  historyUndo: () => set((state) => ({ historyCursor: state.historyCursor - 1 })),
  historyRedo: () => set((state) => ({ historyCursor: state.historyCursor + 1 })),
  resetHistory: () => {
    set({
      historyData: [],
      historyCursor: -1,
    })
  },
}))

export const useNodeHistoryStore = () => {
  return nodeHistoryStore(useShallow((s) => s))
}
